import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Bullet, Content, Label } from './styles';
export const RadioButton = ({ className, children, ...rest }) => {
    return (_jsxs(Label, { className, htmlFor: rest.id, children: [_jsx("input", { type: 'radio', ...rest }), _jsx(Bullet, {}), _jsx(Content, { children: children })] }));
};
//# sourceMappingURL=RadioButton.js.map